import React, { Fragment } from 'react';
import { fieldPathBuilders } from '../../../../../shared/configs/acceptanceForm';
import { useFormWatch } from '../../../../../../../helpers/formManager';
import ClassicTab from './ClassicTab';
import IntervalsPerDayBlock from './IntervalsPerDayBlock';
import { intervalTypesMap } from '../../../../../shared/configs/selectionData/intervalTypes';
import FetchDataWrapper from '../../../../../../../components/FetchDataWrapper';
import { useTimeIntervalsQuery } from '../../../../../api/timeIntervals';
import styles from './index.module.scss';

const { intervalType: createIntervalTypeName } = fieldPathBuilders.desk;

const components = {
  [intervalTypesMap.classic]: ClassicTab,
  [intervalTypesMap.byInterval]: Fragment,
};

const DayTabContent = ({ deskIndex, entityKey, children }) => {
  const intervalType = useFormWatch({
    name: createIntervalTypeName(deskIndex),
    exact: true,
  });

  const Component = components[intervalType];

  if (!Component) return null;

  const commonProps = { deskIndex, entityKey };
  const componentProps =
    intervalType === intervalTypesMap.classic ? commonProps : {};

  return (
    <TabLayout>
      <Component {...componentProps}>
        <IntervalsPerDayBlock {...commonProps} />
        {children}
      </Component>
    </TabLayout>
  );
};

export default DayTabContent;

function TabLayout({ children }) {
  const { data, isFetching, refetch } = useTimeIntervalsQuery();

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Не удалось получить данные для настройки интервалов"
    >
      <div className={styles.layout}>{children}</div>
    </FetchDataWrapper>
  );
}
